import { continuePendingClaim } from "@/lib/accountClaimFlow";

export function accountAuthErrorKey(mode, error) {
  if (!error?.response) return "account.error.network";
  return mode === "login" ? "account.error.login" : "account.error.register";
}

export async function authenticateAndContinue({
  mode,
  login,
  register,
  claimResult,
  email,
  password,
  profile,
  fallbackReturnTo,
}) {
  const account = mode === "register" && profile
    ? await register(email, password, profile)
    : await (mode === "register" ? register : login)(email, password);
  if (account?.status === "deleting") {
    return {
      attempted: false,
      claimed: false,
      deletionResume: true,
      returnTo: "/account/settings",
    };
  }
  return continuePendingClaim(claimResult, fallbackReturnTo);
}
